// extracted by mini-css-extract-plugin
module.exports = {"sm_snackbar":"styles__sm_snackbar--3eXZb"};